import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Database, TrendingUp, RefreshCw } from 'lucide-react';

interface WarehouseActionsProps {
  onRunDimensions: () => void;
  onRunFacts: () => void;
  onRefreshMarts: () => void;
  loading: boolean;
}

export const WarehouseActions = ({
  onRunDimensions,
  onRunFacts,
  onRefreshMarts,
  loading,
}: WarehouseActionsProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>ETL Actions</CardTitle>
        <CardDescription>
          Manually trigger ETL jobs or refresh analytics marts
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-3">
        <Button
          onClick={onRunDimensions}
          disabled={loading}
          variant="outline"
          className="flex-1 min-w-[200px] pointer-events-auto"
        >
          <Database className="mr-2 h-4 w-4" />
          Load Dimensions
        </Button>
        <Button
          onClick={onRunFacts}
          disabled={loading}
          variant="outline"
          className="flex-1 min-w-[200px] pointer-events-auto"
        >
          <TrendingUp className="mr-2 h-4 w-4" />
          Run Incremental ETL
        </Button>
        <Button
          onClick={onRefreshMarts}
          disabled={loading}
          className="flex-1 min-w-[200px] pointer-events-auto"
        >
          <RefreshCw className="mr-2 h-4 w-4" />
          Refresh Marts
        </Button>
      </CardContent>
    </Card>
  );
};
